// extracted by mini-css-extract-plugin
module.exports = {"AdSlotSticky":"zm_a bag_bj bag_ny","AdSlotSticky__slot":"zm_b bag_cx","AdSlotSticky__slot--left":"zm_c bag_sa","AdSlotSticky__slot--right":"zm_e bag_sb"};